module.exports = __webpack_public_path__ + "static/media/7.f5a39c35.JPG";